<div class="events-summary-container">
  <div class="summary-header">
    <h2>Events Summary</h2>
    <button class="close-btn" aria-label="Close modal" (click)="closeDialog()">&times;</button>
  </div>

  <div class="summary-details">
    <div class="detail-group" *ngFor="let detail of alertDetails">
      <span class="label">{{detail?.label}}</span>
      <span class="value" *ngIf="detail?.key !== 'severity' && detail?.key !== 'shift'">{{detail?.value}}</span>
      <span *ngIf="detail?.key === 'shift'" class="d-flex gap-10">
        <span>{{ detail?.value | titlecase }}</span>
        <span class="shift-indication-wrap" *ngIf="data?.eventDetails?.shiftTimeIndication === 'night'">
          <img src="../../../../assets/images/bedtime.svg" title="Night" alt="night">
          <span>{{ data?.eventDetails?.shiftTimeIndication | titlecase }}</span>
        </span>
        <span class="shift-indication-wrap" *ngIf="data?.eventDetails?.shiftTimeIndication === 'day'">
          <img src="../../../../assets/images/clear_day.svg" title="Day" alt="day">
          <span>{{ data?.eventDetails?.shiftTimeIndication | titlecase }}</span>
        </span>
      </span>
      <span class="sensor-cond-style value {{detail.value}}" *ngIf="detail?.key === 'severity'">{{detail?.value |
        translate}}</span>
    </div>
  </div>

  <div class="video-evidence">
    <div class="evidence-toolbar">
      <h3>Video Evidence</h3>
    </div>

    <div class="evidence-toolbar">
      <div class="clip-selectors">
        <div class="clip-btn" *ngFor="let clip of videoClips" (click)="setClip(clip)"
          [class.active]="activeClip?.id === clip.id">
          {{ clip?.file }}
        </div>
      </div>
      <!-- <div class="ai-feed-btn">
        <img src="../../../../assets/images/magic-wand.svg" class="ai-feed-icon" title="AI Rendered Feed" alt="ai">
        <span>AI Rendered Feed</span>
      </div> -->
    </div>

    <!-- Video player: guard when activeClip or url is not yet ready -->
    <div class="video-player-wrapper">
      <ng-container *ngIf="activeClip?.url; else loadingVideo">
        <vg-player (onPlayerReady)="onPlayerReady($event)">
          <vg-controls [vgAutohide]="true" [vgAutohideTime]="3">
            <vg-play-pause></vg-play-pause>
            <vg-playback-button></vg-playback-button>
            <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
            <vg-scrub-bar>
              <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
              <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
            </vg-scrub-bar>
            <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
            <vg-mute></vg-mute>
            <vg-volume></vg-volume>
            <vg-fullscreen></vg-fullscreen>
          </vg-controls>
          <video [vgMedia]="$any(media)" #media id="singleVideo" preload="auto" [src]="activeClip.url">
          </video>
        </vg-player>
      </ng-container>

      <ng-template #loadingVideo>
        <div class="video-loading-state">Loading video...</div>
      </ng-template>
    </div>
  </div>
</div>